import { Box } from '@mui/material'
import React from 'react'
import { ConfirmWithDialogButton } from 'shared/ui'
import { useTransferJobFlowId, useTransferOwnership } from './hooks'
import { PollingFlowStatus } from '../contentService/PollingFlowStatus'
import {
  ContentServiceFlowStatus,
  GDriveFile,
  RequestError,
} from '../contentService/types'
import { isRequestError } from '../contentService/utility'
import { BorderedContainer } from '../utility/Containers'

export function CurrentUser({ files }: { files: GDriveFile[] }) {
  const { transferTo, userFileCount, doTransfer, canTransfer, currentUser } =
    useTransferOwnership(files)

  return (
    <BorderedContainer>
      <Box>{`Your Files: ${userFileCount}`}</Box>
      <Box padding="10px">
        <Box>{`Name: ${currentUser.name}`}</Box>
        <Box>{`Email: ${currentUser.email}`}</Box>
        <Box padding="5px">
          <ConfirmWithDialogButton
            disabled={!canTransfer}
            dialogTitle="Transfer Ownership"
            dialogContent={
              <Box>
                {`Transfer ownership of ${userFileCount} files to ${transferTo}?`}
              </Box>
            }
            onClick={doTransfer}
          >
            Transfer Ownership
          </ConfirmWithDialogButton>
        </Box>
        <Box>
          <CurrentTransferJob />
        </Box>
      </Box>
    </BorderedContainer>
  )
}

function CurrentTransferJob() {
  const [currentStatus, setCurrentStatus] = React.useState<
    ContentServiceFlowStatus | RequestError
  >()
  const [flowId] = useTransferJobFlowId()
  if (!flowId) return null

  const completed =
    !!currentStatus &&
    !isRequestError(currentStatus) &&
    currentStatus.data.completed

  return (
    <Box>
      {completed && (
        <Box>
          <Box>Transfer Job Completed</Box>
          <Box>
            To see refreshed file status, delete this job and create new job for
            file status.
          </Box>
        </Box>
      )}
      <PollingFlowStatus flowId={flowId} onFlowPoll={setCurrentStatus} />
    </Box>
  )
}
